import { useState } from 'react';
import { Globe, TwitterLogo, LinkedinLogo, FacebookLogo, Upload, Sparkle } from '@phosphor-icons/react';

const TABS = [
  { id: 'default', icon: Globe,         label: 'Default',  short: 'Default' },
  { id: 'twitter', icon: TwitterLogo,   label: 'Twitter',  short: 'X' },
  { id: 'linkedin',icon: LinkedinLogo,  label: 'LinkedIn', short: 'In' },
  { id: 'facebook',icon: FacebookLogo,  label: 'Facebook', short: 'FB' },
];

export default function CustomLinkPreview({ value, onChange }) {
  const [activeTab, setActiveTab] = useState('default');

  const current = value?.[activeTab] || {};
  const update = (field, val) => {
    onChange({
      ...value,
      [activeTab]: { ...(value?.[activeTab] || {}), [field]: val },
    });
  };

  return (
    <div className="space-y-3">
      {/* Tab bar — icon + compact label, fits 4 tabs in 300px column */}
      <div className="grid grid-cols-4 gap-1 bg-muted rounded-lg p-1">
        {TABS.map(({ id, icon: Icon, short }) => (
          <button
            key={id}
            type="button"
            onClick={() => setActiveTab(id)}
            title={TABS.find(t => t.id === id)?.label}
            className={`flex flex-col items-center justify-center gap-0.5 py-1.5 rounded-md text-[10px] font-semibold transition-all min-w-0 ${
              activeTab === id
                ? 'bg-white text-foreground shadow-soft'
                : 'text-muted-foreground hover:text-foreground'
            }`}
          >
            <Icon size={13} weight={activeTab === id ? 'fill' : 'regular'} />
            <span className="truncate leading-none">{short}</span>
          </button>
        ))}
      </div>

      {/* Fields */}
      <div className="space-y-2">
        <input
          type="text"
          value={current.title || ''}
          onChange={(e) => update('title', e.target.value)}
          placeholder="OG Title"
          className="w-full h-9 rounded-lg border border-border bg-white px-3 text-xs text-foreground placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-primary/20 focus:border-primary transition-shadow"
        />
        <textarea
          value={current.description || ''}
          onChange={(e) => update('description', e.target.value)}
          placeholder="OG Description"
          rows={2}
          className="w-full rounded-lg border border-border bg-white px-3 py-2 text-xs text-foreground placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-primary/20 focus:border-primary transition-shadow resize-none"
        />
        <input
          type="url"
          value={current.image || ''}
          onChange={(e) => update('image', e.target.value)}
          placeholder="OG Image URL"
          className="w-full h-9 rounded-lg border border-border bg-white px-3 text-xs text-foreground placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-primary/20 focus:border-primary transition-shadow"
        />
      </div>

      {/* Preview card */}
      {(current.title || current.image) && (
        <div className="rounded-xl border border-border bg-white overflow-hidden shadow-soft">
          {current.image && (
            <img
              src={current.image}
              alt="OG preview"
              className="w-full h-24 object-cover"
              onError={(e) => { e.target.style.display = 'none'; }}
            />
          )}
          <div className="p-3">
            {current.title && (
              <p className="text-xs font-semibold text-foreground line-clamp-1">{current.title}</p>
            )}
            {current.description && (
              <p className="text-[10px] text-muted-foreground line-clamp-2 mt-0.5">{current.description}</p>
            )}
          </div>
        </div>
      )}
    </div>
  );
}
